export default {
	Title: 'Báo cáo',
	AllReport: 'Tất cả báo cáo',
	GroupInvoiceList: 'Bảng kê hóa đơn đầu vào',
	GroupInvoiceListThirdParty: 'Bảng kê hóa đơn',
	GroupRiskControl: 'Kiểm soát rủi ro đầu vào',
	GroupRiskControlThirdParty: 'Kiểm soát rủi ro',
	GroupCostManagement: 'Quản lý chi phí đầu vào',
	GroupCostManagementThirdParty: 'Quản lý chi phí',
	SearchReportPlaceHoler: 'Tìm tên báo cáo',
	ReportList: {
		SearchPlaceHolder: 'Nhập Số hóa đơn, Tên nhà cung cấp, Mã số thuế nhà cung cấp, Mã số thuế người mua, Ghi chú để tìm kiếm',
		SearchPlaceHolderRest: 'Nhập Số hóa đơn, Tên nhà cung cấp, Mã số thuế nhà cung cấp, Mã số thuế người mua...',
		SearchPlaceHolderReportInvoiceRelated: 'Nhập Số hóa đơn, Tên nhà cung cấp, MST nhà cung cấp để tìm kiếm.',
		SearchPlaceHolderReportInvoiceStick: 'Nhập Tên nhãn dán để tìm kiếm.',
		ReportName: 'Tên báo cáo',
		ReportInvoiceRiskBySupplier: 'Báo cáo hóa đơn rủi ro theo nhà cung cấp',
		ReportInvoiceSupplierActive: 'Báo cáo hóa đơn theo tình trạng hoạt động của nhà cung cấp',
		ReportInvoiceRelated: 'Báo cáo hóa đơn thay thế, điều chỉnh',
		ReportInvoiceStick: 'Báo cáo thống kê chi phí theo nhãn dán',
		ReportExceedFiveMillion: 'Báo cáo nhà cung cấp có tổng giá trị hóa đơn từ 5 triệu/ngày',
		ReportInvoiceGeneralPurchase: isCheckThirdParty =>
			isCheckThirdParty
				? 'Bảng kê hóa đơn hàng hóa, dịch vụ (tổng hợp)'
				: 'Bảng kê hóa đơn hàng hóa, dịch vụ mua vào (tổng hợp)',
		ReportInvoiceDetailPurchase: isCheckThirdParty =>
			isCheckThirdParty
				? 'Bảng kê hóa đơn hàng hóa, dịch vụ (chi tiết)'
				: 'Bảng kê hóa đơn hàng hóa, dịch vụ mua vào (chi tiết)',
		SupplierActiveTitle: 'Báo cáo hóa đơn theo tình trạng hoạt động của nhà cung cấp',
		SupplierActiveTab1: 'Tại ngày hiện tại',
		SupplierActiveTab2: 'Tại ngày hóa đơn',
		FilterReport: 'Lọc báo cáo',
		ReportCostSummary: 'Báo cáo tổng hợp chi phí',
		ReportExceedCost: 'Báo cáo hóa đơn vượt định mức',
		ReportTypeAndCost: 'Báo cáo loại chi phí và định mức'
	},
	SelectDateRangeReport: 'Bạn chưa chọn khoảng thời gian báo cáo',
	InvoiceProcessStatus: 'Trạng thái xử lý hóa đơn',
	LastUpdateInfo: 'Xem cách lấy số liệu báo cáo',
	InvoiceStatus: 'Trạng thái xử lý hóa đơn',
	StickOne: 'Nhãn dán 1',
	StickTwo: 'Nhãn dán 2',
	StickThree: 'Nhãn dán 3',
	SeemInvoiceAdjust: 'Xem hóa đơn sai sót',
	SeemInvoiceReplacement: 'Xem hóa đơn thay thế, điều chỉnh',
	NotPermissonInvoice: 'Không có quyền Xem hóa đơn',
	DescriptionNotPremissonInvoice:
		'Hóa đơn thuộc đơn vị mà bạn không có quyền làm việc. Vui lòng liên hệ người dùng có quyền Quản trị để được phân quyền.',
	Instruction: {
		InstructionTitle: 'Hướng dẫn xem Bảng kê',
		InstructionContent: {
			Text: (isGeneral, isCheckThirdParty) =>
				`Chương trình ghi nhận bạn muốn xem Bảng kê hóa đơn hàng hóa, dịch vụ ${isCheckThirdParty ? '' : 'mua vào'
				} ${isGeneral ? '(tổng hợp)' : '(chi tiết)'}, vui lòng thực hiện thao tác sau:`,
			Step1: 'Chuyển sang phân hệ ',
			AftefStep1: isCheckThirdParty => (isCheckThirdParty ? 'Hóa đơn' : 'Hóa đơn đầu vào'),
			Step2: isCheckThirdParty =>
				isCheckThirdParty ? 'Tại màn hình hóa đơn chọn ' : 'Tại màn hình hóa đơn đầu vào chọn ',
			AftefStep2: 'điều kiện lọc ',
			AftefStep2_1: '(nếu cần) và nhấn nút ',
			AftefStep2_2: 'Xuất khẩu',
			Step3: 'Tại màn hình xuất khẩu chọn ',
			AftefStep3: 'bảng kê ',
			AftefStep3_1: 'và nhấn nút ',
			AfterStep3_2: 'Xuất khẩu ',
			AfterStep3_3: 'để tải xuống'
		},
		SwitchToInvoiceList: isCheckThirdParty =>
			isCheckThirdParty ? 'Chuyển sang Hóa đơn' : 'Chuyển sang Hóa đơn đầu vào'
	},
	InvoiceListStick: {
		Title: 'Danh sách hóa đơn',
		InvoiceNo: 'Số hóa đơn',
		InvoiceDate: 'Ngày hóa đơn',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		Supplier: 'Nhà cung cấp',
		TotalAmount: 'Tổng tiền',
		BuyerName: 'Người mua hàng',
		ResultChecker: 'Kết quả kiểm tra',
		InvoiceStatus: 'Trạng thái hóa đơn',
		SellerTaxCode: 'Mã số thuế',
		TotalAmountVAT: 'Tiền thuế',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		InvoiceTotalHasDiscount: 'Doanh thu chưa thuế',
		ViewInvoiceList: 'Xem danh sách hóa đơn'
	},
	GuideLine: 'Số liệu có thể chưa chính xác trong một số trường hợp đặc biệt.',
	GuideLineLink: 'Xem hướng dẫn',
	AmountExceedCost: 'Số tiền vượt định mức',
	ExceedCostRate: 'Tỷ lệ vượt định mức',
	ShowUnclassifiedCost: 'Hiển thị chi phí chưa phân loại',
	ShowUnclassifiedCostTooltip: 'Hiển thị thêm số liệu của nhóm hóa đơn chưa được phân loại chi phí',
	UnclassifiedCost: 'Chi phí chưa phân loại',
	MsgBoxContent: `<div style="font-size: 16px; margin-bottom: 8px; font-weight: 700;text-align: center;">Quá trình phân tích đang diễn ra</div><span>AVA đang phân tích dữ liệu trên phần mềm và sẽ trả về kết quả tại <span class="font-bold">Thông báo quả chuông</span> sau ít phút.</span>`,
	NoDataCosttypeMonth:
		'Chức năng chỉ được thực hiện khi có ít nhất một loại chi phí phát sinh dữ liệu và tổng chi phí trong kỳ khác 0. Xem hướng dẫn phân loại chi phí <span style="color: #00A2CF; cursor: pointer" @click="abc">tại đây</span>.',
	NoAnalysisData:
		'Chương trình hiện chỉ đáp ứng chức năng phân tích biến động khi tham số thời gian báo cáo là <span class="font-bold">Quý</span> và Loại chi phí là <span class="font-bold">Tất cả.</span>',
	AnalysisReport: 'Phân tích biến động số liệu chi phí',
	AnalysisInProgress: 'Đang phân tích dữ liệu, vui lòng đợi...',
	ComparisonPeriod: 'Kỳ so sánh',
	CompareType: 'Loại so sánh',
	ViewLastestHistory: 'Xem kết quả phân tích gần nhất',
	NoHistoryAnalysis: 'Không có kết quả phân tích gần nhất',
	AnalysisReportProcessingAlert: 'Hệ thống đang phân tích. Vui lòng đợi trong giây lát.',
	InvoicesPerDay: 'Danh sách hóa đơn trong ngày của nhà cung cấp',
	OnlyCash: 'Chỉ hiển thị hình thức thanh toán Tiền mặt',
	OnlyAmountFromFiveMillion: 'Chỉ hiển thị hóa đơn từ 5 triệu',
	NoData: 'Báo cáo không có số liệu.',
	Filter: 'Bộ lọc',
	ApplyFilter: 'Áp dụng',
	InvoiceDateShort: 'Ngày HĐ',
	FilterHover: 'Lọc'
};
